import {Component, OnInit} from '@angular/core';
import {FeatureSet} from "../../core/statistics-page-menu/statistics-page-menu.component";
import {ExportsService} from "../../core/services/exports.service";
import {map} from "rxjs/operators";
import {ProductKpiService} from "../services/product-kpi.service";
import {environment} from "../../../environments/environment";
import {KPIS} from '../../core/kpi-modules';
import { of } from 'rxjs';

@Component({
  selector: 'cintas-product-age-summary-detail',
  templateUrl: './product-age-summary-detail.component.html',
  styleUrls: ['./product-age-summary-detail.component.scss']
})
export class ProductAgeSummaryDetailComponent implements OnInit {

  chartInfo = KPIS.productAgeSummary.description;
//export is hidden
  features: FeatureSet = {
    export: false
  };

  exportLoading = false;

  data$;

  view = environment.theme.baseView;
  colorScheme = environment.theme.colorPalette;

  // options
  showLegend = true;

  constructor(private productService: ProductKpiService, private exportService: ExportsService) {
  }

  ngOnInit() {
    this.data$ = of([
      { name: 'Sweat Jacket XL', avg_age_in_days: 180, value: 417.6, no_old_items: 20 },
      { name: 'Sweat Jacket L', avg_age_in_days: 175, value: 450, no_old_items: 18 },
      { name: 'Sweat Jacket M', avg_age_in_days: 170, value: 475.8, no_old_items: 15 },
      { name: 'Sweat Jacket S', avg_age_in_days: 165, value: 490, no_old_items: 12 },
      { name: 'Poloshirt XL', avg_age_in_days: 200, value: 361.6, no_old_items: 25 },
      { name: 'Poloshirt L', avg_age_in_days: 195, value: 375.3, no_old_items: 22 },
      { name: 'Poloshirt M', avg_age_in_days: 190, value: 390.8, no_old_items: 20 },
      { name: 'Poloshirt S', avg_age_in_days: 185, value: 256.8, no_old_items: 17 }
    ]);
  }

  onExport() {
    this.exportLoading = true;
    this.exportService.exportAgeSummaryReport()
      .subscribe(response => {
        this.exportLoading = false;
        this.exportService.saveToFileSystem(response);
      }, err => {
        this.exportLoading = false;
      });
  }


}
